import type { ButtonsDef } from "kaplay";

export const BUTTONS = {
    left: { keyboard: ["left", "a"], keyboardCode: ["Numpad4", "Numpad7", "Numpad1"], gamepad: "dpad-left" },
    right: { keyboard: ["right", "d"], keyboardCode: ["Numpad6", "Numpad9", "Numpad3"], gamepad: "dpad-right" },
    pedal: { keyboard: ["down", "s"], keyboardCode: "Numpad2", gamepad: "dpad-down" },
    brake: { keyboard: ["up", "w"], keyboardCode: "Numpad8", gamepad: "east" },
    jump: { keyboard: "space", keyboardCode: ["Numpad0", "Numpad5"], gamepad: "south" },
    boost: { keyboard: "f", keyboardCode: "NumpadAdd", gamepad: "rshoulder" },
    bell: { keyboard: "e", gamepad: "west" },
    pause: { keyboard: ["p", "escape"], gamepad: "start" },
    restart: { keyboard: "r" },
} satisfies ButtonsDef;

export type ButtonName = keyof typeof BUTTONS;

export const TOUCH = {
    flickMinPx: 60,
    flickMaxS: 0.25,
    deadZonePx: 24,
    maxDxPx: 220,
    popWindowS: 0.15,
    stickRadiusPx: 70,
    stickDeadZone: 0.15,
    stickPedalY: 0.5,
    stickBrakeY: 0.5,
};

export const POINTER = {
    deadZone: 12,
    pedalBelow: 160,
    pedalWithPointer: false,
};
